import React from 'react';

const Icon = ({ size = '40', fill = 'url(#prefix_dxc-svg-to-react_a)', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="M34.892 22.51a1.25 1.25 0 0 1 1.882 1.647l-5.834 6.667a1.25 1.25 0 0 1-1.69.175l-3.334-2.5a1.25 1.25 0 0 1 1.5-1.998l2.404 1.803 5.072-5.794Zm-2.695-3.343V14.34l-10.948 6.333v12.505l2.302-1.302a1.25 1.25 0 1 1 1.23 2.176l-2.664 1.505.002.002a4.241 4.241 0 0 1-4.234.002L7.426 29.585l-.005-.002a4.24 4.24 0 0 1-2.119-3.667V13.96l.01-.277a4.239 4.239 0 0 1 2.11-3.388l.004-.004 10.46-5.976v.001A4.237 4.237 0 0 1 20 3.75c.741 0 1.47.197 2.112.566l.002-.001 10.459 5.976.005.004a4.24 4.24 0 0 1 2.119 3.665v5.207a1.25 1.25 0 0 1-2.5 0Zm-23.09-6.958L20 18.509l4.233-2.45L13.35 9.786 9.108 12.21ZM20 6.25c-.305 0-.605.08-.87.233l-.005.003-3.261 1.862 10.867 6.266 4.159-2.405-10.017-5.723-.004-.003a1.74 1.74 0 0 0-.87-.233ZM7.817 26.14a1.738 1.738 0 0 0 .85 1.275l10.083 5.762V20.672L7.802 14.341v11.574l.015.226Z"
                fill="url(#a)"
            />

            <defs>
                <linearGradient id="a" x1="34.326" y1="43.48" x2="-0.513" y2="42.731" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
